import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { initialState } from '../constants.js';
import { HoneycombState } from '../types/state.js';

export const HoneycombStoreContext = createContext<Store<HoneycombState>>(
  createStore<HoneycombState>(initialState),
);

HoneycombStoreContext['displayName'] = 'HoneycombStoreContext';
